const byBuildingAndFloorTypes = {
  floor: 'Floor',
  building: 'Building',
};

export default byBuildingAndFloorTypes;
